import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class Upgrade implements MutableValue {
  public isNew = true;

  private fCreatedAt?: Date;
  private fShortName?: string;

  constructor(
    private fId: string,
    private fCode: string,
    private fName: string
  ) {
    [fId, fCode, fName].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id() {
    return this.fId;
  }

  get code() {
    return this.fCode;
  }

  get name() {
    return this.fName;
  }

  get createdAt() {
    return this.fCreatedAt;
  }

  get shortName() {
    return this.fShortName;
  }
}
